import React, { useMemo, useState } from 'react';
import Styles from './Confirmation.css';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import Accordion from '../../widgets/Accordion/Accordion';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import { SIMULATION_STEPS } from '../../model/simulation-steps';
import Button from '../../widgets/Button/Button';
import clsx from 'clsx';
import { useScroll } from '../../../../utils/useLayout';
import { useRevertStatus } from '../../api/use-revert-status';
import { getErrorData } from '../../shared/utils/error';

function Confirmation() {
  const { scrollToTop } = useScroll();
  const { simulationStep, offer, setSimulationStep, token, showErrorStep } =
    useSimuladorEnergiaSolarState();
  const [openAccordion, setOpenAccordion] = useState([0, 1, 2]);
  const revert = useRevertStatus({ token });

  const hidden = simulationStep?.id !== SIMULATION_STEPS.END_CONFIRMATION.id;

  const renderData = useMemo(() => {
    if (!offer || !offer.details || hidden) return [];

    const details = offer.details;

    const project = {
      icon: 'assets/simulador-energia-solar/jornada/ic-proposal-offer.svg',
      title: 'Projeto',
      data: {
        'Loja responsável': details.storeName,
        'Potência (KWP)': offer?.estimateKitPotency,
        'Valor do projeto': details.projectValue,
        Entrada: details.entryValue,
        'Valor da parcela': details.installmentValue,
        'Quantidade de parcelas': details.installmentQuantity,
      },
    };

    if (offer?.shouldHideResume) {
      delete project.data['Potência (KWP)'];
    }

    const insurance = {
      icon: 'assets/simulador-energia-solar/jornada/ic-proposal-insurance.svg',
      title: 'Seguros',
      data: {
        [`${details.insuranceName}`]: details.insuranceValue,
      },
    };

    const taxes = {
      icon: 'assets/simulador-energia-solar/jornada/ic-proposal-taxes.svg',
      title: 'Taxas e impostos',
      data: {
        'Tarifa de cadastro': details.tariffRegister,
        'Registro de contrato': details.registerContractFee,
        IOF: details.taxIOF,
        'Taxa de juros mensais': details.interestRate,
        'Taxa de juros anuais': details.interestRateYearly,
        'CET mensal': details.feeCET,
        'CET anual': details.feeCETYearly,
        'Valor financiado': details.financedValue,
        'Valor total financiado': details.financedTotalValue,
      },
    };

    return [project, insurance, taxes].map((item, i) => ({
      ...item,
      id: i,
      data: Object.entries(item.data).map(([key, value]) => ({
        key,
        value,
        keyWithHtml: /<b>.*<\/b>/.test(key),
      })),
    }));
  }, [hidden, offer]);

  const handleSubmit = async () => {
    setSimulationStep(SIMULATION_STEPS.FORM_PERSONAL_DATA);
    scrollToTop();
  };

  const handleBack = async () => {
    try {
      await revert.mutateAsync({});
      setSimulationStep(SIMULATION_STEPS.FORM_PROPOSAL);
      scrollToTop();
    } catch (error) {
      showErrorStep({
        ...getErrorData(error),
        ctx: 'api-revert-status',
      });
    }
  };

  if (hidden) return null;

  return (
    <>
      <div className="confirmation">
        <ContainerHome24>
          <h6 className="text-title">Resumo e confirmação</h6>
          <p className="text-subtitle">
            Confira abaixo o resumo da simulação e as condições escolhidas para enviar a simulação
            da proposta.
          </p>

          {renderData.map((item, index) => {
            return (
              <Accordion
                id={`confimation-item-${item.id}`}
                key={`item-${item.id}`}
                open={openAccordion.includes(item.id)}
                setOpen={(v) => {
                  setOpenAccordion((prev) => {
                    if (v) {
                      return [...prev, item.id];
                    } else {
                      return prev.filter((id) => id !== item.id);
                    }
                  });
                }}
                title={
                  <div className="custom-acc-head">
                    <img alt="" src={item.icon} />
                    <p>{item.title}</p>
                  </div>
                }
              >
                <div
                  className={clsx({
                    'data-grid': true,
                    'data-grid-last': index === renderData.length - 1,
                  })}
                >
                  {item.data.map((data) => {
                    return (
                      <React.Fragment key={`${data.key}-${data.value}-${item.id}`}>
                        {data.keyWithHtml ? (
                          <p className="data-key" dangerouslySetInnerHTML={{ __html: data.key }} />
                        ) : (
                          <p className="data-key">{data.key}</p>
                        )}
                        <p className="data-value">{data.value}</p>
                      </React.Fragment>
                    );
                  })}
                </div>
              </Accordion>
            );
          })}

          <div className="data-grid total">
            <p className="data-key">Total</p>
            <p className="data-value">{offer?.details?.totalLabel || 'Carregando'}</p>
          </div>

          <div className="btns-wrapper">
            <Button
              variant="white"
              onClick={() => {
                handleBack();
              }}
            >
              Voltar
            </Button>

            <Button
              variant="red"
              onClick={() => {
                handleSubmit();
              }}
            >
              Continuar
            </Button>
          </div>
        </ContainerHome24>
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

export default Confirmation;
